<template>
  <div>
    <div class="form-row">
      <label for="email">Email</label>
      <input id="email" class="form-control" type="text" v-model="customer.email"/><br/>
    </div>
    <div class="form-row">
      <label for="firstName">Vorname</label>
      <input id="firstName" class="form-control" type="text" v-model="customer.firstName"/><br/>
    </div>
    <div class="form-row">
      <label for="lastName">Nachname</label>
      <input id="lastName" class="form-control" type="text" v-model="customer.lastName"/><br/>
    </div>
    <div class="form-row">
      <label for="phone">Telefon</label>
      <input id="phone" class="form-control" type="text" v-model="customer.phone"/><br/>
    </div>
    <div class="mt-3 text-right">
      <div class="btn btn-success" @click="$emit('input', customer)">Speichern</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object
  },
  data() {
    return {
      customer: {
        email: '',
        firstName: '',
        lastName: '',
        phone: ''
      }
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal && newVal.id)
          this.customer = this.value
      },
      immediate: true
    }
  }
}
</script>
